module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-Light.1131525.ttf";